import * as React from 'react';
import { List, ListItemText, makeStyles, Badge, Typography } from '@material-ui/core';
import { Icon } from '@mitie/material-ui-extensions';
import {
	faLayerGroup,
	faEdit,
	faIdCardAlt,
	faPollPeople,
	faBadgePercent,
	faExclamationTriangle,
	faBellSchool,
	faBox,
	faBullhorn,
	faHistory,
} from '@fortawesome/pro-light-svg-icons';
import {
	faLayerGroup as faLayerGroupSolid,
	faEdit as faEditSolid,
	faIdCardAlt as faIdCardAltSolid,
	faBadgePercent as faBadgePercentSolid,
	faPollPeople as faPollPeopleSolid,
	faExclamationTriangle as faExclamationTriangleSolid,
	faBellSchool as faBellSchoolSolid,
	faBox as faBoxSolid,
	faBullhorn as faBullhornSolid,
	faHistory as faHistorySolid,
} from '@fortawesome/pro-solid-svg-icons';
import { stores } from '../../store';
import { IHeaderNavProps } from '../../types';
import { observer } from 'mobx-react-lite';
import sidebarUseStyles from '../../assets/css/SideBarCss';
import GlobalStyle from 'assets/css/SidebarStyled';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
	textStyle: {
		marginLeft: '-18px',
	},

	textStylefeed: {
		marginLeft: '8px',
	},
	feedBadge: {
		'& span': {
			backgroundColor: theme.palette.warning.main,
			fontSize: '0.7rem',
			left: '0px',
			top: '-2px',
			transform: 'scale(0.8) translate(50%, -50%)',
		},
		'@media(max-width:1024px)': {
			left: '-5px',
			top: '0px',
			transform: 'scale(0.6) translate(50%, -50%)',
		},
	},
	listChildItemSelected: {
		backgroundColor: '#CFDBE5',
	},
}));

const HeaderNav = observer((props: IHeaderNavProps) => {
	const routes = React.useContext(stores.context.routes);
	const user = React.useContext(stores.context.user);
	const { routeName } = routes;
	const appStores = React.useContext(stores.context.appStores);
	const feed = React.useContext(stores.context.feed);
	const classesUseStyles = useStyles();
	const classesSideBar = sidebarUseStyles();
	const classes = props.classNames;
	const [selectedItem, setSelectedItem] = React.useState('');
	const [selectedMenuItem, setSelectedMenuItem] = React.useState('');
	const [currentFeedItems, setCurrentFeedItems] = React.useState(0);
	const [showFloorPlans, setShowFloorPlans] = React.useState(0);
	const contentManagementList: string[] = [
		'announcements',
		'announcementsEditor',
		'delivery',
		'evacuation',
		'evacuationEditor',
		'incident',
		'promotion',
		'promotionEditor',
		'survey',
		'surveyEditor',
		'surveyReport',
		'visitor',
	];
	const contentManagementListSelected = !!routeName && !!contentManagementList.includes(routeName);
	const [open, setOpen] = React.useState(
		routeName === 'feed' || routeName === 'archive' || contentManagementListSelected,
	);
	const [openCont, setOpenCont] = React.useState(false || contentManagementListSelected);
	const [contentClicked, setContentClicked] = React.useState(false);
	React.useEffect(() => {
		if (selectedItem === routeName || selectedMenuItem === routeName || (contentClicked && !openCont)) {
			navigateToPage('feed');
		}
		const mainFeedCount =
			feed.mainFeedItems && feed.mainFeedItems.Pagination && feed.mainFeedItems.Pagination.TotalFeedCount;
		const statusFeedCount =
			feed.statusFeedItems && feed.statusFeedItems.Pagination && feed.statusFeedItems.Pagination.TotalFeedCount;
		setCurrentFeedItems(mainFeedCount + statusFeedCount);
	}, [feed.statusFeedItems, feed.mainFeedItems, selectedItem, routeName, selectedMenuItem]);
	const navigateToPage = (route: string) => {
		routes.navigate(
			{
				name: route,
			},
			{ clearParams: true },
		);
	};
	const handleClick = () => {
		setOpenCont(!openCont);
		setOpen(true);
		setContentClicked(true);
	};
	React.useEffect(() => {
		if (user.permissions && user.permissions.Modules) {
			const feedIndex = user.permissions.Modules.findIndex(
				(m: any) => m.ModuleId === '9DB69870-10EC-4BDC-8EF9-6C1D6BB39291',
			);

			if (user.permissions.Modules[feedIndex] && user.permissions.Modules[feedIndex].Read) {
				if (
					user.permissions.Modules[feedIndex].Create &&
					user.permissions.Modules[feedIndex].Update &&
					user.permissions.Modules[feedIndex].Delete
				) {
					setShowFloorPlans(1);
				}
			} else {
				setShowFloorPlans(0);
			}
		} else {
			setShowFloorPlans(0);
		}
	}, [user.permissions]);

	return (
		<>
			<GlobalStyle />
			<List
				component={'ul'}
				disablePadding={false}
				className={props.drawerOpen ? classes.sideBarList : classes.miniSideBarList}
			>
				<li
					title={!props.drawerOpen ? 'Feed' : ''}
					aria-current="page"
					onClick={() => {
						appStores.showAppLoader = true;
						routes.navigate(
							{ name: 'feed' },
							{
								clearParams: true,
							},
						);
						appStores.drawerOpen = false;
						setOpen(true);
					}}
				>
					<a
						aria-label={routeName === 'feed' ? 'Feed Current' : 'Feed'}
						style={{ marginTop: '6px' }}
						href="javascript:void(0)"
						className={clsx(
							'ancharTag',
							{
								subMenuMiniSideBar: !props.drawerOpen,
							},
							routeName === 'feed' || routeName === 'archive' || contentManagementListSelected
								? 'selected'
								: 'main-menu',
						)}
					>
						<span className={classes.listIcon} style={{ display: 'inline-flex' }}>
							<React.Fragment>
								{currentFeedItems === 0 || currentFeedItems === null ? (
									''
								) : (
									<Badge
										badgeContent={currentFeedItems || '0'}
										color="primary"
										className={classesUseStyles.feedBadge}
										anchorOrigin={{
											vertical: 'top',
											horizontal: 'right',
										}}
									>
										<Typography />
									</Badge>
								)}
								<Icon
									icon={
										routeName === 'feed' || routeName === 'archive' || contentManagementListSelected
											? faLayerGroupSolid
											: faLayerGroup
									}
								/>
							</React.Fragment>
						</span>
						{props.drawerOpen && <ListItemText primary="Feed" />}
					</a>
				</li>

				{open && (
					<li>
						<nav>
							<List
								component={'ul'}
								disablePadding={false}
								className={props.drawerOpen ? classesSideBar.contentMenuFeed : classesSideBar.miniContentMenuFeed}
							>
								<li
									title={!props.drawerOpen ? 'Archive' : ''}
									onClick={() => {
										navigateToPage('archive');
										setSelectedMenuItem('archive');
										appStores.drawerOpen = false;
										setTimeout(() => {
											document.getElementById('Archive')?.focus();
										}, 50);
									}}
								>
									<a
										aria-label={routeName === 'archive' ? 'Archive Current' : 'Archive'}
										href="javascript:void(0)"
										className={clsx(
											'ancharTag',
											{
												subMenuMiniSideBar: !props.drawerOpen,
												selected: selectedMenuItem === 'archive' || routeName === 'archive',
											},
											selectedMenuItem === 'archive' || routeName === 'archive' ? 'sub-menu-selected' : 'sub-menu',
										)}
									>
										<span className={classes.listIcon}>
											<Icon icon={routeName === 'archive' ? faHistorySolid : faHistory} />
										</span>
										{props.drawerOpen && <ListItemText primary="Archive" />}
									</a>
								</li>

								{showFloorPlans === 1 && (
									<li
										title={!props.drawerOpen ? 'Content Management' : ''}
										onClick={() => {
											handleClick();
											setSelectedMenuItem('contentManagement');
										}}
										aria-expanded={openCont}
									>
										<button
											aria-label={openCont ? 'Collapse content management' : 'Expand content management'}
											aria-expanded={openCont}
											aria-controls="content-management-collapse"
											className={clsx(
												'ancharTag buttonFocus',
												{
													subMenuMiniSideBar: !props.drawerOpen,
												},
												contentManagementListSelected || openCont ? 'selected sub-menu-selected' : 'sub-menu',
											)}
										>
											<span className={classes.listIcon}>
												<Icon icon={contentManagementListSelected || openCont ? faEditSolid : faEdit} />
											</span>
											{props.drawerOpen && <ListItemText primary="Content Management" style={{ textAlign: 'left' }} />}
										</button>

										{openCont && (
											<List component={'ul'} disablePadding={false} id="content-management-collapse" aria-live="polite">
												<li
													title={!props.drawerOpen ? 'Announcements' : ''}
													onClick={() => {
														navigateToPage('announcements');
														setSelectedItem('announcements');
														appStores.drawerOpen = false;
														setTimeout(() => {
															document.getElementById('Announcements')?.focus();
														}, 50);
													}}
												>
													<a
														aria-label={routeName === 'announcements' ? 'Announcements Current' : 'Announcements'}
														href="javascript:void(0)"
														className={clsx(
															'ancharTag',
															{
																subMenuMiniSideBar: !props.drawerOpen,
															},
															routeName === 'announcements' || routeName === 'announcementsEditor'
																? 'selected sub-menu-selected'
																: 'sub-menu',
														)}
													>
														<span className={classes.listIcon}>
															<Icon
																icon={
																	(contentManagementListSelected && routeName === 'announcements') ||
																	routeName === 'announcementsEditor'
																		? faBullhornSolid
																		: faBullhorn
																}
															/>
														</span>
														{props.drawerOpen && <ListItemText primary="Announcements" />}
													</a>
												</li>

												<li
													title={!props.drawerOpen ? 'Delivery' : ''}
													onClick={() => {
														navigateToPage('delivery');
														setSelectedItem('delivery');
														appStores.drawerOpen = false;
														setTimeout(() => {
															document.getElementById('deliveryPage')?.focus();
														}, 50);
													}}
												>
													<a
														aria-label={routeName === 'delivery' ? 'Delivery Current' : 'Delivery'}
														href="javascript:void(0)"
														className={clsx(
															'ancharTag',
															{
																subMenuMiniSideBar: !props.drawerOpen,
															},
															routeName === 'delivery' ? 'selected sub-menu-selected' : 'sub-menu',
														)}
													>
														<span className={classes.listIcon}>
															<Icon
																className={classes.listIcon}
																icon={contentManagementListSelected && routeName === 'delivery' ? faBoxSolid : faBox}
															/>
														</span>
														{props.drawerOpen && <ListItemText primary="Delivery" />}
													</a>
												</li>

												<li
													title={!props.drawerOpen ? 'Evacuation test' : ''}
													onClick={() => {
														navigateToPage('evacuation');
														setSelectedItem('evacuation');
														appStores.drawerOpen = false;
														setTimeout(() => {
															document.getElementById('evacutionTestPage')?.focus();
														}, 50);
													}}
												>
													<a
														aria-label={routeName === 'evacuation' ? 'Evacuation Test Current' : 'Evacuation Test'}
														href="javascript:void(0)"
														className={clsx(
															'ancharTag',
															{
																subMenuMiniSideBar: !props.drawerOpen,
															},
															routeName === 'evacuation' || routeName === 'evacuationEditor'
																? 'selected sub-menu-selected'
																: 'sub-menu',
														)}
													>
														<span className={classes.listIcon}>
															<Icon
																icon={
																	(contentManagementListSelected && routeName === 'evacuation') ||
																	routeName === 'evacuationEditor'
																		? faBellSchoolSolid
																		: faBellSchool
																}
																className={(classes.listIcon, classes.listIconMargin)}
															/>
														</span>
														{props.drawerOpen && <ListItemText primary="Evacuation test" />}
													</a>
												</li>

												<li
													title={!props.drawerOpen ? 'Incident' : ''}
													onClick={() => {
														navigateToPage('incident');
														setSelectedItem('incident');
														appStores.drawerOpen = false;
														setTimeout(() => {
															document.getElementById('Incident')?.focus();
														}, 50);
													}}
												>
													<a
														aria-label={routeName === 'incident' ? 'Incident Current' : 'Incident'}
														href="javascript:void(0)"
														className={clsx(
															'ancharTag',
															{
																subMenuMiniSideBar: !props.drawerOpen,
															},
															routeName === 'incident' ? 'selected sub-menu-selected' : 'sub-menu',
														)}
													>
														<span className={classes.listIcon}>
															<Icon
																icon={
																	contentManagementListSelected && routeName === 'incident'
																		? faExclamationTriangleSolid
																		: faExclamationTriangle
																}
																className={(classes.listIcon, classes.listIconMargin)}
															/>
														</span>
														{props.drawerOpen && <ListItemText primary="Incident" />}
													</a>
												</li>

												<li
													title={!props.drawerOpen ? 'Promotion' : ''}
													onClick={() => {
														navigateToPage('promotion');
														setSelectedItem('promotion');
														appStores.drawerOpen = false;
														setTimeout(() => {
															document.getElementById('Promotions')?.focus();
														}, 50);
													}}
													onKeyDown={(e: any) => {
														if (e.key === 'Enter') {
															navigateToPage('promotion');
															setSelectedItem('promotion');
															appStores.drawerOpen = false;
															setTimeout(() => {
																document.getElementById('Promotions')?.focus();
															}, 50);
														}
													}}
												>
													<a
														aria-label={routeName === 'promotion' ? 'Promotion Current' : 'Promotion'}
														href="javascript:void(0)"
														className={clsx(
															'ancharTag',
															{
																subMenuMiniSideBar: !props.drawerOpen,
															},
															routeName === 'promotion' || routeName === 'promotionEditor'
																? 'selected sub-menu-selected'
																: 'sub-menu',
														)}
													>
														<span className={classes.listIcon}>
															<Icon
																icon={
																	(contentManagementListSelected && routeName === 'promotion') ||
																	routeName === 'promotionEditor'
																		? faBadgePercentSolid
																		: faBadgePercent
																}
															/>
														</span>
														{props.drawerOpen && <ListItemText primary="Promotion" />}
													</a>
												</li>

												<li
													title={!props.drawerOpen ? 'Survey' : ''}
													onClick={() => {
														navigateToPage('survey');
														setSelectedItem('survey');
														appStores.drawerOpen = false;
														setTimeout(() => {
															document.getElementById('surveyPage')?.focus();
														}, 50);
													}}
												>
													<a
														aria-label={routeName === 'survey' ? 'Survey Current' : 'Survey'}
														href="javascript:void(0)"
														className={clsx(
															'ancharTag',
															{
																subMenuMiniSideBar: !props.drawerOpen,
															},
															routeName === 'survey' || routeName === 'surveyEditor'
																? 'selected sub-menu-selected'
																: 'sub-menu',
														)}
													>
														<span className={classes.listIcon}>
															<Icon
																icon={
																	(contentManagementListSelected && routeName === 'survey') ||
																	routeName === 'surveyEditor'
																		? faPollPeopleSolid
																		: faPollPeople
																}
																className={(classes.listIcon, classes.listIconMargin)}
															/>
														</span>

														{props.drawerOpen && <ListItemText primary="Survey" />}
													</a>
												</li>

												<li
													title={!props.drawerOpen ? 'Visitor' : ''}
													onClick={() => {
														navigateToPage('visitor');
														setSelectedItem('visitor');
														appStores.drawerOpen = false;
														setTimeout(() => {
															document.getElementById('visitorPage')?.focus();
														}, 50);
													}}
												>
													<a
														aria-label={routeName === 'visitor' ? 'Visitor Current' : 'Visitor'}
														href="javascript:void(0)"
														className={clsx(
															'ancharTag',
															{
																subMenuMiniSideBar: !props.drawerOpen,
															},
															routeName === 'visitor' ? 'selected sub-menu-selected' : 'sub-menu',
														)}
													>
														<span className={classes.listIcon}>
															<Icon
																className={(classes.listIcon, classes.listIconMargin)}
																icon={
																	contentManagementListSelected && routeName === 'visitor'
																		? faIdCardAltSolid
																		: faIdCardAlt
																}
															/>
														</span>
														{props.drawerOpen && <ListItemText primary="Visitor" />}
													</a>
												</li>
											</List>
										)}
									</li>
								)}
							</List>
						</nav>
					</li>
				)}
			</List>
		</>
	);
});

export default HeaderNav;
